// Helpers for the CUPP3 library release manifest.
//
// The manifest is embedded in index.html as
//   <script type="application/json" id="cupp3-library-manifest"> ... </script>
// so that cupp3-predict can fetch https://cupp.info/downloads (or
// /library/release) — both serve index.html — and parse the same JSON that the
// /downloads and /library/release pages render from. This keeps a single source
// of truth that is visible to both the browser and the command-line tool.

const MANIFEST_ID = "cupp3-library-manifest";

export function loadManifest() {
  const empty = { current: "", releases: {} };
  if (typeof document === "undefined") return empty;
  const el = document.getElementById(MANIFEST_ID);
  if (!el || !el.textContent) return empty;
  try {
    const m = JSON.parse(el.textContent);
    return {
      current: m.current || "",
      releases: m.releases || {},
    };
  } catch (e) {
    return empty;
  }
}

function normalizePart(part) {
  const p = part || {};
  return {
    filename: p.filename || "",
    doi: p.doi || "",
    url: p.url || "",
    md5: p.md5 || "",
    size: typeof p.size === "number" ? p.size : 0,
  };
}

// Release objects as a list, current first then version-descending.
export function releaseList(manifest) {
  const releases = (manifest && manifest.releases) || {};
  const current = (manifest && manifest.current) || "";
  const rows = Object.keys(releases).map((version) => {
    const r = releases[version] || {};
    return {
      version,
      date: r.date || "",
      library: normalizePart(r.library),
      meta: normalizePart(r.meta),
    };
  });
  rows.sort((a, b) => {
    if (a.version === current) return -1;
    if (b.version === current) return 1;
    return b.version.localeCompare(a.version, undefined, { numeric: true });
  });
  return rows;
}

export function doiUrl(doi) {
  if (!doi) return "";
  return doi.startsWith("http") ? doi : `https://doi.org/${doi}`;
}

export function formatSize(bytes) {
  const n = Number(bytes) || 0;
  if (n <= 0) return "—";
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(v >= 10 ? 0 : 1)} ${units[i]}`;
}

// The legacy (pre-CUPP3) CUPP programs, hosted on Zenodo. Shown on both the
// /downloads and /download_cupp3 pages. These are direct Zenodo download links.
export const legacyDownloads = [
  {
    title: "CUPP (Python, v1.0.14): clustering & prediction",
    subtitle: "Original Python implementation (CUPP_v1.0.14)",
    url: "https://zenodo.org/api/records/23248690/files/CUPP_v1.0.14.tar.gz/content",
  },
  {
    title: "CUPP 2023 release (Ru-CUPP): precompiled predictor & library",
    subtitle: "The 2023 CUPP platform release (CUPP_2023)",
    url: "https://zenodo.org/api/records/23248714/files/CUPP_2023.tar.gz/content",
  },
];
